import CheckDevice from '../../Modules/CheckDevice.js';
import * as CustomProperty from '../../Modules/CustomProperty.js';
import Animation from '../../Modules/Animation.js';
import DrawerMenu from '../../Modules/DrawerMenu.js';
import Modal from '../../Modules/Modal.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import Slider from '../../Modules/Slider.js';
import * as CustomScroll from '../../Modules/CustomScroll.js';
import SmoothScroll from '../../Modules/SmoothScroll.js';
import * as Accordion from '../../Modules/Accordion.js';
import ClickToggleClass from '../../Modules/ClickToggleClass.js';
import * as Tab from '../../Modules/Tab.js';
import * as CvVisible from './Modules/CvVisible.js';


const preinit = (e) => {
  UpdateStatus.load();
}

const init = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  Slider();
  DrawerMenu.init();
  Modal.init();
  CustomScroll.init();
  SmoothScroll();
  Accordion.css();
  Accordion.init();
  ClickToggleClass();
  Tab.init();
  CvVisible.init();
}

const resize = () => {
  UpdateStatus.resize();
  CheckDevice();
  CustomProperty.resize();
  CustomScroll.resize();
  Accordion.css();
  CvVisible.check();
}

const resizeW = () => {
  CustomProperty.resizeW();
  Accordion.css();
}

const scroll = () => {
  UpdateStatus.scroll();
  CustomProperty.scroll();
  Animation();
  CvVisible.check();
}

const load = () => {
  UpdateStatus.load();
  Animation();
  Accordion.css();
  CvVisible.check();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}